import { render } from "./pannellumApi.vue?vue&type=template&id=7ec40641"
import script from "./pannellumApi.vue?vue&type=script&lang=js"
export * from "./pannellumApi.vue?vue&type=script&lang=js"

import "./pannellumApi.vue?vue&type=style&index=0&id=7ec40641&lang=scss"

import exportComponent from "/var/www/vhosts/emblematic.es/tour.emblematic.es/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__